import { logApiError } from '~/utils/logger'

export default defineNuxtRouteMiddleware(async to => {
  const siteAccess = useCookie('site_access')
  const supabase = useSupabaseClient()

  // Allow access to certain paths without checking maintenance mode
  const allowedPaths = [
    '/under-construction',
    '/auth',
    '/login',
    '/register',
    '/confirm',
    '/api/',
  ]

  // Check if current path starts with any allowed path
  const isAllowedPath = allowedPaths.some(path => to.path.startsWith(path))

  // Always allow admin routes - admins need access
  const isAdminRoute = to.path.startsWith('/admin')

  // If the user is on the under-construction page
  if (to.path === '/under-construction') {
    // If they already have access, send them home
    if (siteAccess.value === 'granted')
      return navigateTo('/')

    // Otherwise let them stay
    return
  }

  // Skip check for allowed paths and admin routes
  if (isAllowedPath || isAdminRoute)
    return

  // Check if maintenance mode is enabled from API
  try {
    const { value: maintenanceEnabled } = await $fetch<{ value: boolean }>(
      '/api/maintenance/under_construction_mode',
    )

    // If maintenance mode is not enabled, allow access
    if (!maintenanceEnabled)
      return

    // Maintenance mode is enabled, check user access

    // Check if user has site_access cookie (password bypass)
    if (siteAccess.value === 'granted')
      return

    // Check if user is logged in and is admin
    const {
      data: { user },
    } = await supabase.auth.getUser()

    if (user) {
      // Use the permissions API to check if user can access admin panel
      // This properly uses the new permission system via RPC
      try {
        const userData = await $fetch<{
          permissions?: Record<string, Record<string, boolean>>
        }>('/api/auth/me')

        const hasAdminAccess
          = userData?.permissions?.admin_panel?.access
            || userData?.permissions?.camps?.manage

        if (hasAdminAccess)
          return
      }
      catch {
        // If we can't fetch permissions, fall through to redirect
      }
    }

    // User doesn't have access - redirect to under-construction
    return navigateTo('/under-construction')
  }
  catch (error) {
    // If there's an error fetching the setting, allow access (fail-safe)
    logApiError('/middleware/under-construction', error, { route: to.path })
  }
})
